<template>
    <div class="table-main">
        <div class="main-head">
            <div>罚单编号</div>
            <div>罚单日期</div>
            <!-- <div>周期</div> -->
            <div>罚单类型</div>
            <div>快币金额(币)</div>
            <div>处罚原因</div>
        </div>
        <z-scrollDiv class="main-wrap">
            <div class="main-item" v-for="item in dataList" :key="item.id">
                <div>{{ item.code }}</div>
                <div>{{ item.created_at }}</div>
                <!-- <div>{{ shareCycle(item) }}</div> -->
                <div class="overhide" :title="item.ticket_name">{{ item.ticket_name }}</div>
                <div>{{ item.ticket_amount }}</div>
                <div class="overhide" :title="item.remark">{{ item.remark }}</div>
            </div>
            <z-noData :list="dataList"></z-noData>
        </z-scrollDiv>
    </div>
</template>

<script>
    export default {
        props:["dataList"],
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    .table-main{
        @paddL:30px;
        height:calc(~"100% - @{page-h}");
        .main-head,.main-item{
            box-sizing: border-box;
            padding-left: @paddL;
            &:after{
                content:"";
                display: block;
                clear: both;
            }

            >div{
                float: left;
                width: 13%;
                &:nth-of-type(5){
                    width: 46%;
                    padding-right: 2%;
                }
            }
        }

        .main-head{
            height: 34px;
            line-height: 34px;
            background: #f2f2f2;
            font-size: 14px;
            color: #333;
        }

        .main-item{
            color:#808080;
            font-size: 12px;
            height: 40px;
            line-height: 39px;
            box-sizing: border-box;
            border-bottom: 1px solid #e6e6e6;
        }

        .main-wrap{
            height: calc(~"100% - 34px + 1px");
            overflow: auto;
        }

    }
</style>





// WEBPACK FOOTER //
// ticketTable.vue?7815cfca